import Avatar from 'react-avatar';
import './AppAvatar.scss';

function AppAvatar({
    maxInitials = 2,
    size = '48',
    color = '#EEEFF3',
    fgColor = '#000',
    round = true,
    src,
    name,
    ...props
}) {
    const numericSize = Number(size);
    const fontSize = Math.ceil(numericSize / 3);

    return (
        <Avatar
            className="appAvatar"
            maxInitials={maxInitials}
            size={size}
            color={color}
            fgColor={fgColor}
            round={round}
            src={src}
            name={name}
            style={{ fontSize: `${fontSize}px` }}
            {...props}
        />
    );
}
export default AppAvatar;
